export default __webpack_public_path__ + "static/media/mission.d96affa0.png";